import { createContext } from 'react'

const HomepageCarouselContext = createContext(false)

export default HomepageCarouselContext
